module.exports = __webpack_public_path__ + "static/img/plan3.62893e1.png";


//////////////////
// WEBPACK FOOTER
// ./src/assets/home/plan3.png
// module id = yOxo
// module chunks = 1